import React from 'react';
import ServiceWork from "../../../components/pages/grid/ServiceWork/ServiceWork";

const ServiceWorkGridPage = () => {
    return <ServiceWork />;
};

export default ServiceWorkGridPage;
